module.exports = __webpack_public_path__ + "src/assets/images/download_icon.bbc940cddf7f3d662c95b139f3377663.svg";